
const LocationPermissionSvg = ({ width = 200, height = 159 }) => (
  <img
    src={'https://d2djimvzddgguw.cloudfront.net/humbee-address/location-permission.png'}
    alt=''
    width={width}
    height={height}
    style={{ objectFit: 'contain', display: 'block' }}
  />
);

export default LocationPermissionSvg;
